import React from 'react';
import { createRoot } from 'react-dom/client';
import { yaMetrikaInit } from 'shared/lib/metrics/metrics';
import { initCommon } from 'shared/lib/common-init';

import './assets/index.scss';
import { isIframe } from 'shared/lib/is-iframe';
import { initI18 } from './localization';

const container = document.getElementById('root');
const root = createRoot(container!);

yaMetrikaInit(isIframe() ? 'iframe_widget' : 'main_app');
initCommon();

async function initApp() {
  if (isIframe()) {
    document.documentElement.classList.remove('bg-surface-section');
    const { DbsFrame } = await import('widgets/DbsFrame/DbsFrame');
    root.render(<DbsFrame />);
    return;
  }
  const { initFlomniChat } = await import('shared/lib/init-flomni-chat');
  initFlomniChat();
  const { App } = await import('./App');
  root.render(<App />);
}

initI18().then(initApp);
